<template>

</template>

<script>

    import filteringFromObject from "../../utils/filteringFromObject";

    export default {

        name: "SongMixin",

        methods: {
            async load(page = undefined) {
                if (page) {
                    this.songs.current_page = page;
                }

                this.loading = true;

                try {
                    const response = await this.$http.get(this.songUrl, {
                        params: {
                            page: this.songs.current_page,
                            order: this.order,
                            duplicate_filter: this.duplicate_filter,
                            filters: filteringFromObject(this.filtering)
                        }
                    });

                    let song_data = response.data;

                    song_data.data.map((song) => {
                        song.playing = false;
                        return song;
                    })

                    this.songs = song_data;
                } catch (exception) {
                    // alert('Failed to load songs');
                }

                this.loading = false;
            },
        }
    }
</script>

<style scoped>

</style>
